import React from "react";
import DashboardLayout from "../../layout/DashboardLayout";

const CommingSoon = () => {
  return (
    <>
      <DashboardLayout>
        <div className="flex min-h-[90vh] items-center justify-center h-96 bg-gradient-to-br from-blue-50 to-sky-100">
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg
                className="w-8 h-8 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <h1 className="text-4xl font-bold text-blue-600 mb-4">
              Coming Soon
            </h1>

            <p className="text-gray-600 text-lg">
              We're working on something great!
            </p>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default CommingSoon;
